/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyHospitalAssociation from './pharmacy-hospital-association';
import PharmacyHospitalAssociationDetail from './pharmacy-hospital-association-detail';
import PharmacyHospitalAssociationUpdate from './pharmacy-hospital-association-update';
import PharmacyHospitalAssociationDeleteDialog from './pharmacy-hospital-association-delete-dialog';

const PharmacyHospitalAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyHospitalAssociation />} />
    <Route path="new" element={<PharmacyHospitalAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyHospitalAssociationDetail />} />
      <Route path="edit" element={<PharmacyHospitalAssociationUpdate />} />
      <Route path="delete" element={<PharmacyHospitalAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyHospitalAssociationRoutes;
